export default {"src":"/_next/static/media/courses.25fb37b3.svg","height":21,"width":22};